import React from 'react';
import { Card, CardHeader, CardBody } from '../ui/Card';
export function WhatWeDoForYou() {
  const services = [{
    title: 'Travel Logistics',
    items: ['Custom Room Blocks', 'Flight coordination', 'On-Ground Transportation', 'VIP arrivals & departures']
  }, {
    title: 'Event Curation, Programming & Design',
    items: ['Custom agendas', 'Brand storytelling', 'Motivational Activities', 'Expert trainers', 'Theme development', 'Brand activations']
  }, {
    title: 'Production & Logistics',
    items: ['Venue consulting', 'Vendor management', 'On-site team', 'Risk management']
  }, {
    title: 'Event Technologies',
    items: ['Custom mobile apps', 'Graphic design', 'Websites', 'AV solutions', 'QRs', 'Virtual Chats']
  }, {
    title: 'Wellness & Community Integration',
    items: ['Fitness activities', 'Eco & CSR Friendly Team Builders']
  }, {
    title: 'Global Expert Network',
    items: ['Specialized training, strategy & development from a world-class roster of professors & industry leaders']
  }];
  return <section className="py-16 bg-[#F4E8D0]/30" data-id="element-279">
      <div className="container mx-auto px-4 md:px-6" data-id="element-280">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-281">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-282">
            What <span className="text-[#0099A1]" data-id="element-283">DestaMeet</span> Does for you
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-284">
            Every DestaMeet experience includes comprehensive support from our
            expert team.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-285">
          {services.map((service, index) => <Card key={index} className="h-full" data-id="element-286">
              <CardHeader data-id="element-287">
                <h3 className="text-lg font-bold text-[#0099A1]" data-id="element-288">
                  {service.title}
                </h3>
              </CardHeader>
              <CardBody data-id="element-289">
                <ul className="space-y-2" data-id="element-290">
                  {service.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start text-sm text-[#374047]/80" data-id="element-291">
                      <span className="text-[#0099A1] mr-2" data-id="element-292">•</span>
                      <span data-id="element-293">{item}</span>
                    </li>)}
                </ul>
              </CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}